<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useQuasar } from 'quasar'
import { useAuthStore } from '../stores/authStore'
import { myRequest } from '../utils/fetch'
const router = useRouter()
const $q = useQuasar()
const authStore = useAuthStore()

const userId = ref('')
const isLoading = ref(false)

async function handleImpersonate() {
  if (!userId.value) {
    $q.notify({
      color: 'negative',
      message: 'Please enter a user ID'
    })
    return
  }

  try {
    isLoading.value = true
    await myRequest('GET', `/auth/loginAs/${userId.value}`)

    $q.notify({
      color: 'positive',
      message: 'Successfully impersonating user'
    })

    authStore.checkWithServer()

    // Redirect to home page after successful impersonation
    router.push('/')
  } catch (error) {
    $q.notify({
      color: 'negative',
      message: 'Failed to impersonate user'
    })
  } finally {
    isLoading.value = false
  }
}
</script>

<template>
  <q-page class="q-pa-md">
    <div class="row justify-center">
      <div class="col-12 col-md-6">
        <q-card class="q-pa-md">
          <q-card-section>
            <div class="text-h5 q-mb-md">Admin User Impersonation</div>

            <q-form @submit="handleImpersonate" class="q-gutter-md">
              <q-input v-model="userId" label="User ID" :rules="[(val) => !!val || 'User ID is required']" outlined />

              <div class="row justify-end">
                <q-btn type="submit" color="primary" :loading="isLoading" label="Impersonate User" />
              </div>
            </q-form>
          </q-card-section>
        </q-card>
      </div>
    </div>
  </q-page>
</template>
